export const buttonStyles = {
  Button: {
    baseStyle: () => ({
      color: 'white',
    }),
    variants: {
      text: {
        padding: 0,
        paddingInlineEnd: 0,
        paddingInlineStart: 0,
        minW: 'auto',
        h: 'auto',
      },
      lightBlue: {
        backgroundColor: '#32A173',
        _hover: {
          bg: 'green.400',
        },
      },
      darkBlue: {
        backgroundColor: '#32A173',
        _hover: {
          bg: 'green.400',
        },
      },
      actionBlue: {
        bg: '#32A173',
        color: 'white',
        _hover: {
          bg: 'green.400',
        },
        _disabled: {
          bg: '#38A169 !important',
          color: 'white',
          opacity: 0.6,
        },
      },
    },
  },
}
